// extracted by mini-css-extract-plugin
export default {"menu_item":"LanguageSwitcher_menu_item__1cUYG","globe_button":"LanguageSwitcher_globe_button__yCx3g"};